import script from "./ShoppingCart.vue?vue&type=script&setup=true&lang=js"
export * from "./ShoppingCart.vue?vue&type=script&setup=true&lang=js"

import "./ShoppingCart.vue?vue&type=style&index=0&id=fb74be3a&lang=scss&scoped=true"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb74be3a"]])

export default __exports__